import React, { useEffect, useRef } from 'react';

export function etarDisplayTitle(item) {
  const fields = [item?.nomenclature, item?.subject].map(value => String(value || '').trim()).filter(Boolean);
  return [...new Set(fields)].join(' | ') || item?.etarNumber || 'Waiver';
}

export function matchedEtarTasks(item) {
  return item?.matchedRequirements || (item?.matchedRequirement ? [item.matchedRequirement] : []);
}

export function waiverCoverageLabel(waivers, tasks) {
  return `${waivers} waiver${waivers === 1 ? '' : 's'} covering ${tasks} task${tasks === 1 ? '' : 's'}`;
}

export function etarCoverageLabel(item) {
  return waiverCoverageLabel(1, matchedEtarTasks(item).length);
}

export default function EtarTaskPicker({ etarNumber, requirements, selectedIds, disabled, saved, onChange }) {
  const detailsRef = useRef(null);
  useEffect(() => {
    if (saved && detailsRef.current) detailsRef.current.open = false;
  }, [saved]);

  return (
    <details ref={detailsRef} className="crystal-ball__etar-task-picker">
      <summary>Select tasks ({selectedIds.length})</summary>
      <div role="group" aria-label={`Tasks covered by ${etarNumber}`}>
        {requirements.map(requirement => (
          <label key={requirement.id}>
            <input
              type="checkbox"
              checked={selectedIds.includes(requirement.id)}
              disabled={disabled}
              onChange={event => onChange(event.target.checked
                ? [...selectedIds, requirement.id]
                : selectedIds.filter(id => id !== requirement.id))}
            />
            <span>{requirement.noun || requirement.wuc || '9188-6 task'}{requirement.wuc ? ` | ${requirement.wuc}` : ''}</span>
          </label>
        ))}
      </div>
    </details>
  );
}
